import React from "react";

const FacebookMessenger = () => {
  return (
    <svg
      x="0px"
      y="0px"
      width="566.93px"
      height="566.93px"
      viewBox="0 0 566.93 566.93"
      enableBackground="new 0 0 566.93 566.93"
    >
      <path
        fill="#606060"
        d="M503.139,215.896c-12.377,0.217-19.001-6.643-20.268-18.017c-0.891-7.93-1.58-15.958-3.478-23.663
	c-3.72-15.201-11.77-29.276-24.52-38.591c-6.014-4.378-12.831-7.589-19.968-9.651c-9.075-2.634-18.511-1.902-27.566-4.14
	c-9.825-2.399-15.262-10.387-13.724-19.641c1.408-8.406,9.572-14.968,18.748-14.313c57.322,4.145,98.308,33.853,104.143,101.517
	c0.414,4.758,0.906,9.812-0.157,14.368C514.549,211.592,508.775,215.499,503.139,215.896
	C490.763,216.113,508.775,215.499,503.139,215.896L503.139,215.896z"
      />
      <path
        fill="#606060"
        d="M283.48,0C130.249,0,6.03,116.86,6.03,261.015c0,80.818,39.049,153.051,100.359,200.929
	v104.333l98.544-54.874c24.907,6.904,51.263,10.627,78.547,10.627c153.231,0,277.45-116.86,277.45-261.015
	C560.93,116.86,436.712,0,283.48,0z M313.324,351.297l-71.511-74.193l-138.552,74.193l152.854-158.218l71.511,74.193l136.765-74.193
	L313.324,351.297z"
      />
    </svg>
  );
};

export default FacebookMessenger;
